/* eslint-disable react/prop-types */
import React from "react";
import "./Navigation.css";
import NavBasic from "./NavBasic";
import NavLang from "./NavLang";

const Navigation = () => {
  return (
    <div className="navigation-main">
      <NavBasic />
      <NavLang />
    </div>
  );
};

export default Navigation;
